/**
 * 医師シフトCSVヘッダー定義
 */

/**
 * 期待されるCSVヘッダー
 * タブ区切りCSVファイルのヘッダー行に含まれるべき項目
 */
export const DOCTOR_SHIFT_CSV_HEADERS = [
  '医師id',
  'シフト日付',
  '診療開始時間',
  '診療終了時間'
] as const;

/**
 * CSVヘッダーの型
 */
export type DoctorShiftCsvHeader = typeof DOCTOR_SHIFT_CSV_HEADERS[number];

/**
 * ヘッダーマッピング（日本語から英語フィールド名へ）
 */
export const HEADER_FIELD_MAPPING: Record<DoctorShiftCsvHeader, keyof import('../types/doctorShift').DoctorShiftRecord> = {
  '医師id': 'doctor_id',
  'シフト日付': 'shift_date',
  '診療開始時間': 'start_time',
  '診療終了時間': 'end_time'
};

/**
 * サンプルCSVデータ
 * ユーザーがダウンロードできるサンプルファイルの内容
 */
export const SAMPLE_CSV_DATA = `医師id	シフト日付	診療開始時間	診療終了時間
DR001	2025/07/01	8:00	12:00
DR002	2025/07/01	13:00	17:00
DR001	2025/07/01	14:00	18:00
DR003	2025/07/02	9:00	13:00
DR002	2025/07/02	14:00	18:00`;

/**
 * CSVファイル設定
 */
export const CSV_FILE_CONFIG = {
  maxSizeInMB: 5,
  maxSizeInBytes: 5 * 1024 * 1024, // 5MB
  acceptedTypes: ['.csv', '.tsv', 'text/csv', 'text/tab-separated-values'],
  encoding: ['utf-8', 'shift-jis'] as const
};